import { render, staticRenderFns } from "./CoinBalance.vue?vue&type=template&id=665b866c&"
import script from "./CoinBalance.vue?vue&type=script&lang=js&"
export * from "./CoinBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports